import { useState } from "react";
import {
  Dialog,
  IconButton,
  ListItemIcon,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Delete, Menu } from "@mui/icons-material";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../../../App/Components/Modals/ConfirmationModal";
import { basicSort } from "../../../../App/Helpers/BasicSort";
import {
  deleteJob,
  getFeaturedJobsByGroup,
} from "../../../FeaturedJobsPage/FeaturedJobsService";
import { callAPI } from "../../../../App/Helpers/callApi";
import Signifier from "../../../../App/Components/Signifier/Signifier";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "default !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "default !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    [theme.breakpoints.down("md")]: {
      width: "auto",
    },
    width: "800px",
    color: theme.palette.primary.copy,
  },
}));

export default function DetailedTableCell(props) {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const callDeleteJob = () => {
    callAPI(
      deleteJob(props.element.id),
      "Job Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getFeaturedJobsByGroup(
        props.element.clientId,
        props.element.featureAdGroupId
      ).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        props.setTableData(response);
      });
    });
  };

  function openModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        component={Link}
        to={{
          pathname: "/featuredgroups/featuredgroupsdetailed",
          state: props.element,
        }}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Delete" ? (
              <Tooltip title="Delete Featured Job">
                <IconButton onClick={(e) => openModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : column.label === "" ? (
              <ListItemIcon className={classes.itemIcon}>
                <Menu />
              </ListItemIcon>
            ) : (
              props.element["ad"][column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this featured job?"
          func={() => callDeleteJob()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
    </>
  );
}
